/**
 * Extracts content from parentheses if present, otherwise creates abbreviation from first letters
 */
export const extractFromParentheses = (str: string): string => {
  const match = str.match(/\(([^)]+)\)/)
  if (match) {
    return match[1]
  }

  return str
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase())
    .join('')
}
